// extracted by mini-css-extract-plugin
export default {"switcher":"HeaderThemeSwitcher_switcher__W5Ur3"};